import React from "react";
const EmptyStatePreview = ({ message, link, className }) => {
  return (
    <div className={`${className}`}>
      <div className="text-center">
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M58.6406 16.0529C58.6939 16.6929 58.6406 17.3595 58.4806 18.0262L49.494 54.1061C48.854 56.7995 46.454 58.6662 43.6806 58.6662H8.64061C4.61394 58.6662 1.76065 54.7195 2.93398 50.8529L14.1606 14.7728C14.934 12.2661 17.254 10.5596 19.8673 10.5596H52.6673C55.2273 10.5596 57.3073 12.0796 58.1873 14.2129C58.454 14.7729 58.5873 15.4129 58.6406 16.0529Z"
            fill="#EFEFEF"
          />
          <path
            d="M61.3063 52.32C61.573 55.76 58.853 58.6667 55.413 58.6667H43.6797C46.453 58.6667 48.853 56.7999 49.493 54.1066L58.4797 18.0267C58.6397 17.36 58.693 16.6934 58.6396 16.0534L58.6663 16L61.3063 52.32Z"
            fill="#D9D9D9"
          />
          <path
            d="M25.814 19.013C25.654 19.013 25.494 18.9863 25.334 18.9597C24.2674 18.693 23.6007 17.6264 23.8674 16.5331L26.6407 5.01304C26.9073 3.94637 27.974 3.3064 29.0673 3.5464C30.134 3.81307 30.8007 4.87966 30.5341 5.973L27.7607 17.493C27.5474 18.3997 26.7207 19.013 25.814 19.013Z"
            fill="#D9D9D9"
          />
          <path
            d="M43.6798 19.0404C43.5465 19.0404 43.3865 19.0404 43.2532 18.9871C42.1865 18.7471 41.4932 17.6804 41.7065 16.6137L44.2131 5.04045C44.4531 3.94711 45.5198 3.2804 46.5865 3.49374C47.6532 3.73374 48.3465 4.80044 48.1331 5.86711L45.6265 17.4403C45.4398 18.4003 44.6132 19.0404 43.6798 19.0404Z"
            fill="#D9D9D9"
          />
          <path
            d="M41.8646 34H20.5312C19.4379 34 18.5312 33.0933 18.5312 32C18.5312 30.9067 19.4379 30 20.5312 30H41.8646C42.9579 30 43.8646 30.9067 43.8646 32C43.8646 33.0933 42.9579 34 41.8646 34Z"
            fill="#D9D9D9"
          />
          <path
            d="M39.2005 44.667H17.8672C16.7739 44.667 15.8672 43.7603 15.8672 42.667C15.8672 41.5737 16.7739 40.667 17.8672 40.667H39.2005C40.2939 40.667 41.2005 41.5737 41.2005 42.667C41.2005 43.7603 40.2939 44.667 39.2005 44.667Z"
            fill="#D9D9D9"
          />
        </svg>

        <div className="d-flex pt-3">
          <span className="text-sm text-gray-300">
            {message ? message : "No content added"}
          </span>
          <span className="text-sm text-primary-200 font-bold ms-1">
            {link}
          </span>
        </div>
      </div>
    </div>
  );
};
export default EmptyStatePreview;
